// Shared JWT payload decoder — bug 2026-06-12 (returning user stuck on consent).
//
// Backend claims (apps/api routers/auth.py _issue_access_token):
//   sub (user id, string), tid (telegram id), cid (company id, may be null
//   while pending), role, jti, iat, exp.
//
// Same base64url→atob pattern lives inline in 5 screens (Members, Settings,
// Reports, TripDetails, Carriers) — consolidation of those is a separate
// cleanup; this module is the canonical copy for new call sites.

export interface JwtPayload {
  sub?: string;
  tid?: number;
  cid?: number | null;
  role?: string;
  exp?: number;
}

export function decodeJwtPayload(jwt: string | null): JwtPayload | null {
  if (!jwt) return null;
  const parts = jwt.split(".");
  if (parts.length !== 3) return null;
  const payloadPart = parts[1];
  if (!payloadPart) return null;
  try {
    // base64url → base64 → atob (jsdom-safe)
    const b64 = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
    const json = atob(padded);
    return JSON.parse(json) as JwtPayload;
  } catch {
    return null;
  }
}
